import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { Data } from '../signup-data/DATA';
import { dataInvalid } from '../store/signup-data-validation/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { codeVerificationFailed } from '../store/step-code-verification/action-creators';
export const LOG = Logger.getLogger('handleCompleteVerificationError');
export const handleCodeVerificationError = (error, dispatch, getState) => {
  const state = getState();
  const code = getSignupDataValue(state, Data.CodeVerification);
  dispatch(codeVerificationFailed());
  LOG.error('/completeCodeVerification error', {
    extra: getSentryExtra(error)
  });
  dispatch(dataInvalid({
    dataKey: Data.CodeVerification,
    errorMessage: `data.${Data.CodeVerification}.error.invalidCode`,
    validatedValue: code
  }));
};